import { render, staticRenderFns } from "./MathCaptcha.vue?vue&type=template&id=b1adb114&scoped=true"
import script from "./MathCaptcha.vue?vue&type=script&lang=js"
export * from "./MathCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1adb114",
  null
  
)

export default component.exports